import React, { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import moment from "moment";
import { toast } from "react-toastify";

import AppLayout from "../../components/layout/AppLayout";
import Breadcrumb from "../../components/layout/Breadcrumb";
import VmcReceiveForm from "../../components/vmcReceives/VmcReceiveForm";
import { pageTitleClass } from "../../components/ui/styles";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import {
  clearVmcReceiveOpenOrders,
  fetchVmcReceiveOpenOrders,
  fetchVmcReceiveParties,
  getVmcReceiveOpenOrders,
  getVmcReceiveOpenOrdersLoading,
  getVmcReceivePartyOptions,
} from "../../features/vmcReceives/vmcReceivesSlice";
import { getLoggingUser } from "../../features/loggingUser/loggingUserSlice";
import { POST } from "../../services/axios.service";
import { receiveLinePayload } from "../../static/cuttingLine";
import { hasPermission, permission } from "../../static/permission";
import { route } from "../../static/route";
import { toastStyles } from "../../static/styles";
import { BreadcrumbType } from "../../types/common";
import { IVmcReceiveFormInput } from "../../types/vmcReceive";

const breadcrumbItems: BreadcrumbType[] = [
  { label: "હોમ", href: route.dashboard },
  { label: "VMC રિસીવ", href: route.vmcReceives },
  { label: "નવી રિસીવ" },
];

const VmcReceiveCreatePage = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const partyOptions = useAppSelector(getVmcReceivePartyOptions);
  const openOrders = useAppSelector(getVmcReceiveOpenOrders);
  const openOrdersLoading = useAppSelector(getVmcReceiveOpenOrdersLoading);
  const loggingUser = useAppSelector(getLoggingUser);

  const withRates = hasPermission(
    loggingUser?.permissions,
    permission.vmcRate
  );

  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    dispatch(fetchVmcReceiveParties());
    dispatch(clearVmcReceiveOpenOrders());
  }, [dispatch]);

  const handlePartyChange = useCallback(
    (partyId: number) => {
      if (partyId) {
        dispatch(fetchVmcReceiveOpenOrders({ party_id: partyId }));
      } else {
        dispatch(clearVmcReceiveOpenOrders());
      }
    },
    [dispatch]
  );

  const handleSubmit = async (data: IVmcReceiveFormInput) => {
    setIsSubmitting(true);
    try {
      await POST("/v1/admin/vmc-receives", {
        party_id: data.party_id,
        date: moment(data.date).format("YYYY-MM-DD HH:mm:ss"),
        items: receiveLinePayload(data.items, withRates),
      })
        .then((response: any) => {
          if (response.data.status === "success") {
            toast.success(response.data.message, {
              ...(toastStyles as any),
            });
            navigate(route.vmcReceives);
          } else {
            toast.error(response.data.message, {
              ...(toastStyles as any),
            });
          }
        })
        .catch((error: any) => {
          toast.error(error.data.message, {
            ...(toastStyles as any),
          });
        });
    } catch (error) {
      toast.error("કંઈક ખોટું ગયું, કૃપા કરીને ફરીથી પ્રયત્ન કરો.", {
        ...(toastStyles as any),
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <AppLayout>
      <div className="mb-2 md:mb-0">
        <Breadcrumb items={breadcrumbItems} />
      </div>

      <div className="flex items-center mb-4 md:mb-6 mt-2">
        <h1 className={pageTitleClass}>નવી VMC રિસીવ ઉમેરો</h1>
      </div>

      <div className="flex flex-col gap-6">
        <VmcReceiveForm
          partyOptions={partyOptions}
          openOrders={openOrders}
          openOrdersLoading={openOrdersLoading}
          onPartyChange={handlePartyChange}
          onSubmit={handleSubmit}
          isSubmitting={isSubmitting}
          onCancel={() => navigate(route.vmcReceives)}
          submitLabel="સાચવો"
          withRates={withRates}
        />
      </div>
    </AppLayout>
  );
};
export default VmcReceiveCreatePage;
